// removed by extract-text-webpack-plugin
module.exports = {"ellipsisContainer":"b4_b5","ellipsis":"b4_b6"};


//////////////////
// WEBPACK FOOTER
// ./app/src/components/LoadingEllipsis/styles.module.css
// module id = 1145
// module chunks = 27